export const CompanySettingsTabId = {
  Branding: 'branding',
  DataOutput: 'data-output',
  General: 'general',
  TenantPortal: 'tenant-portal',
  Workflows: 'workflows',
}

export const CompanySettingsSectionId = {
  AboutUs: 'about-us',
  Archive: 'archive',
  ColorTheme: 'color-theme',
  DocFlow: 'docflow',
  EmbeddingCode: 'embedding-code',
  Invitation: 'invitation',
  InvoicesExport: 'invoices-export',
  Logo: 'logo',
  Printers: 'printers',
  Region: 'region',
  Registration: 'registration',
  Requests: 'requests',
  TableConfig: 'table-config',
  Website: 'website',
}

export const COMPANY_SETTINGS_SECTION_TAB_IDS = {
  [CompanySettingsSectionId.AboutUs]: CompanySettingsTabId.TenantPortal,
  [CompanySettingsSectionId.Archive]: CompanySettingsTabId.Workflows,
  [CompanySettingsSectionId.ColorTheme]: CompanySettingsTabId.Branding,
  [CompanySettingsSectionId.DocFlow]: CompanySettingsTabId.Workflows,
  [CompanySettingsSectionId.EmbeddingCode]: CompanySettingsTabId.TenantPortal,
  [CompanySettingsSectionId.Invitation]: CompanySettingsTabId.TenantPortal,
  [CompanySettingsSectionId.InvoicesExport]: CompanySettingsTabId.DataOutput,
  [CompanySettingsSectionId.Logo]: CompanySettingsTabId.Branding,
  [CompanySettingsSectionId.Printers]: CompanySettingsTabId.DataOutput,
  [CompanySettingsSectionId.Region]: CompanySettingsTabId.General,
  [CompanySettingsSectionId.Registration]: CompanySettingsTabId.TenantPortal,
  [CompanySettingsSectionId.Requests]: CompanySettingsTabId.Workflows,
  [CompanySettingsSectionId.TableConfig]: CompanySettingsTabId.DataOutput,
  [CompanySettingsSectionId.Website]: CompanySettingsTabId.General,
}

export const COMPANY_SETTINGS_SECTION_HASH_PREFIX = '#'
